import React from 'react'
import { Box, Typography } from '@material-ui/core'
import Seo from '../Seo/Seo'

const Privacy = () => (
  <Box paddingTop={10} paddingBottom={6} paddingX={{ xs: 2, md: 6 }}>
    <Seo
      title="Privacy Policy | Trivia Weekend"
      description="Read the Trivia Weekend privacy policy to understand what data we collect, how we use it, and your choices."
      canonicalPath="/#/privacy"
      ogType="website"
    />
    <Typography variant="h3" component="h1" gutterBottom>
      Privacy Policy
    </Typography>
    <Typography variant="subtitle1" gutterBottom>
      Last updated: February 5, 2026
    </Typography>

    <Typography paragraph>
      Trivia Weekend is a free, community-driven trivia platform. This Privacy Policy explains what
      information we collect, why we collect it, and the choices you have. We aim to collect as little as
      we can while still making the site work well.
    </Typography>

    <Typography variant="h5" gutterBottom>
      Information We Collect
    </Typography>
    <Typography component="div" paragraph>
      <ul>
        <li>
          <strong>Account info:</strong> such as an email address or username when you create an account or
          sign in.
        </li>
        <li>
          <strong>Usage & device info:</strong> such as IP address, browser/device details, and basic
          analytics about how the site is used (for example: pages visited, clicks, errors, or performance).
        </li>
        <li>
          <strong>Cookies & session data:</strong> session cookies that help keep you signed in and keep
          the site functioning properly.
        </li>
      </ul>
    </Typography>

    <Typography variant="h5" gutterBottom>
      How We Use Information
    </Typography>
    <Typography component="div" paragraph>
      <ul>
        <li>To operate Trivia Weekend and provide core features.</li>
        <li>To authenticate users and maintain account sessions.</li>
        <li>To understand usage trends, improve performance, and fix bugs.</li>
        <li>To respond to questions or support requests.</li>
        <li>To help keep the service secure and prevent abuse.</li>
      </ul>
    </Typography>

    <Typography variant="h5" gutterBottom>
      Sharing With Third Parties
    </Typography>
    <Typography paragraph>
      We do <strong>not</strong> sell your personal information. We may share limited information with
      service providers that help us run the site (for example: hosting, infrastructure, error monitoring,
      or analytics). These providers are only permitted to use data to provide services to Trivia Weekend.
    </Typography>

    <Typography variant="h5" gutterBottom>
      Cookies & Tracking
    </Typography>
    <Typography paragraph>
      Trivia Weekend uses cookies (and similar technologies) for two main reasons:
    </Typography>
    <Typography component="div" paragraph>
      <ul>
        <li>
          <strong>Essential cookies:</strong> to keep you logged in and enable core site functionality.
        </li>
        <li>
          <strong>Basic analytics:</strong> to understand site performance and usage. We use this to improve
          the experience — not to serve targeted advertising.
        </li>
      </ul>
    </Typography>
    <Typography paragraph>
      You can usually control cookies through your browser settings. If you disable essential cookies,
      some parts of the site may not work correctly (like staying signed in).
    </Typography>

    <Typography variant="h5" gutterBottom>
      Data Retention & Security
    </Typography>
    <Typography paragraph>
      We keep information only for as long as needed to provide the service and for legitimate purposes
      like troubleshooting, security, and preventing abuse. We use reasonable administrative, technical,
      and physical safeguards to protect your information, but no method of transmission or storage is
      100% secure.
    </Typography>

    <Typography variant="h5" gutterBottom>
      Your Choices
    </Typography>
    <Typography paragraph>
      If you’d like to request access to, correction of, or deletion of your account information, email us
      at <strong><a href="mailto:triviaweekendapp@gmail.com">triviaweekendapp@gmail.com</a></strong>. We’ll respond within a reasonable timeframe.
    </Typography>

    <Typography variant="h5" gutterBottom>
      Children’s Privacy
    </Typography>
    <Typography paragraph>
      Trivia Weekend is not intended for children under 13, and we do not knowingly collect personal
      information from children under 13. If you believe a child has provided personal information,
      please contact us and we’ll take steps to delete it.
    </Typography>

    <Typography variant="h5" gutterBottom>
      Policy Updates
    </Typography>
    <Typography paragraph>
      We may update this policy from time to time. When we do, we’ll post the updated policy on this page
      and update the “Last updated” date. By continuing to use the service after an update, you agree to
      the revised policy.
    </Typography>

    <Typography variant="h5" gutterBottom>
      Contact Us
    </Typography>
    <Typography paragraph>
      Questions about privacy? Email us at <strong><a href="mailto:triviaweekendapp@gmail.com">triviaweekendapp@gmail.com</a></strong>.
    </Typography>
  </Box>
)

export default Privacy
